/**
@license
Copyright 2020 Google Inc. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { __decorate } from "tslib";
import { customElement } from 'lit-element';
import { ListItemBase } from './mwc-list-item-base';
import { style } from './mwc-list-item-css';
let ListItem = class ListItem extends ListItemBase {
};
ListItem.styles = style;
ListItem = __decorate([
    customElement('mwc-list-item')
], ListItem);
export { ListItem };
//# sourceMappingURL=mwc-list-item.js.map